<template>
	<div class="idi-row">
		<div class="idi-cell">
			<span>{{ value.id }}</span>
		</div>
		<div class="idi-cell">
			<span>{{ value.method_id }}</span>
		</div>
		<div class="idi-cell">
			<span>{{ value.name }}</span>
		</div>
		<div class="idi-cell">
			<span>{{ value.create_time | formatDate(vue) }}</span>
		</div>
		<div class="idi-cell">
			<span v-if="value.active">✓</span>
			<button v-else @click="setActiveCard" class="btn btn-round btn-small">{{ $t('labels.general.set_active') }}</button>
		</div>
	</div>
</template>

<script>
export default {
	props: [
		'user_uid',
		'value'
	],
	data () {
		return {
			vue: this,
			loading: false
		}
	},
	methods: {
		setActiveCard () {
			this.loading = true
			this.$api.subscriptions.paymentMethods.setActiveById(this, this.user_uid, this.value.id)
				.then(response => {
					this.$log.info('payment methods', 'subscriptions.paymentMethods.setActiveById OK', response)()
					this.$root.$emit('add-floating-box', { title: 'Success', text: 'Default card set.' })
					this.$emit('reload')
				}).catch(error => {
					this.$log.error('payment methods', 'subscriptions.paymentMethods.setActiveById ERROR', error)()
				}).finally(() => {
					this.loading = false
				})
		},
	}
}
</script>



// WEBPACK FOOTER //
// src/components/user/profile/subscriptions/PaymentMethodRow.vue